/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/display-name */
/* eslint-disable import/no-anonymous-default-export */
import React, { useCallback, useEffect, useState } from 'react'
import ReactFlow, { Background, addEdge, Controls, Panel } from 'reactflow'
import 'reactflow/dist/base.css'
import CustomNode from './CustomNode'
import AddNodeDrawer from './AddNodeDrawer'
import EditNodeDrawer from './EditNodeDrawer'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'
import { Button } from '../../Common/ui/button'
import { CrossCircledIcon } from '@radix-ui/react-icons'
import CustomEdge from './CustomEdge'
import PropTypes from 'prop-types'
import * as OrgChartTypes from '../../Entities/OnBoardingContainerTypes'
import '../../Styles/OrganizationChart.css'
import { Checkbox } from '../../Common/ui/checkbox'
import { useOnboardingStore } from '../../Containers/Onboarding/Store/OnboardingStore'
import { useCommonStore } from '../../Common/store/CommonStore'
import { cn, ConvertBase64ToFile } from 'src/lib/utils'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import Tooltip from '@mui/material/Tooltip'
import { useNavigate } from 'react-router-dom'
import DatePickerInput from 'src/Common/ui/DatePickerInput'
import { useForm } from 'react-hook-form'
import Textarea from 'src/Common/ui/textArea'
import { toDate } from 'date-fns'
import { IconButton } from '@mui/material'
import EditPencilIcon from 'src/Common/Icon/EditPencilIcon'
import { MdOutlineCancel } from 'react-icons/md'
import { IoCloseSharp } from 'react-icons/io5'
import { IoMdSave } from 'react-icons/io'
import Loading from 'src/Common/ui/Loading'
import { sendInnviteFronOnboarding } from 'src/Containers/Auth/Store/Store'

const nodeTypes = {
    custom: CustomNode
}

const edgeTypes = {
    custom: CustomEdge
}

const OrganizationChart = ({ edges, setEdges, onEdgesChange, nodes, setNodes, onNodesChange, activeStepper }) => {
    const { register, handleSubmit, reset, formState: { errors, isSubmitting, isLoading }, control } = useForm({ mode: 'onChange' })
    const navigate = useNavigate() // Hook for navigation
    const organizationChartData = useOnboardingStore((state) => state.getOrganizationChartData)
    const createOrganizationChart = useOnboardingStore((state) => state.createOrganizationChart)
    const editOrganizationChartNode = useOnboardingStore((state) => state.editOrganizationChartNode)
    const editOrganizationChartNodeLoading = useOnboardingStore((state) => state.editOrganizationChartNodeLoading)
    const getOrganizationChart = useOnboardingStore((state) => state.getOrganizationChart)
    const getOrganizationChartLoading = useOnboardingStore((state) => state.getOrganizationChartLoading)
    const [currentNode, setCurrentNode] = useState({})
    const { getAllRole, rollData, designationByOrgId, departmentByOrgId, getAllDepartmentByOrgId, getAllDesignationByOrgId } = useCommonStore()
    const [newNode, setnewNode] = useState({})
    const [childNodeCount, setChildNodeCount] = useState(0)
    const [addState, setAddState] = React.useState({ right: false })
    const [editState, setEditState] = React.useState({ right: false })
    const [isDeleteModal, setIsDeleteModal] = React.useState(false)
    const [isDeleteModalConfirm, setIsDeleteModalConfirm] = React.useState(false)
    const [roleData, setRoleData] = useState([])
    const [depByOrgId, setDepByOrgId] = useState([])
    const [desByOrgId, setDesByOrgId] = useState([])
    const orgId = localStorage.getItem('orgId')
    const loginId = localStorage.getItem('userId')
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [orgChartEdit, setOrgChartEdit] = useState(false)
    const { getAllFeaturesF } = useCommonStore()

    useEffect(() => {
        if (organizationChartData?.length > 0) {
            setNodes((currentNodes) => {
                // Create a map of current node positions to preserve them
                const currentPositions = {}
                currentNodes?.forEach(node => {
                    if (node?.position) {
                        currentPositions[node.id] = node.position
                    }
                })

                return organizationChartData?.map((mapData) => {
                    // Preserve existing position if the node already exists in the UI
                    const existingPosition = currentPositions[mapData.id]
                    const position = existingPosition || mapData.position

                    return {
                        ...mapData,
                        position, // Use preserved position or backend position for new nodes
                        draggable: activeStepper || orgChartEdit, // Lock nodes if not in edit mode
                        data: {
                            ...mapData?.data,
                            meetingType: [
                                { title: 'Executives Team', isSelected: true },
                                { title: 'Risk Team', isSelected: true },
                                { title: 'Compliance Team', isSelected: true }
                            ],
                            pos: mapData.id === '0' ? { x: 0, y: 0 } : (existingPosition || mapData?.data?.pos),
                            handleDrawerOpen,
                            handleEditDrawerOpen,
                            handleOpenNodeDeleteModal
                        }
                    }
                })
            })
            // Delay setting edges to allow React Flow to render nodes first
            // This ensures edges are calculated with correct node positions
            const rawEdgeData = organizationChartData?.map((data) => data?.nodes)?.filter?.((filterData, ind) => ind !== 0)

            // Deduplicate edges based on source-target combination
            const seenEdges = new Set()
            const edgeData = rawEdgeData?.filter((edge) => {
                if (!edge?.source || !edge?.target) return false
                const edgeKey = `${edge.source}-${edge.target}`
                if (seenEdges.has(edgeKey)) {
                    return false // Skip duplicate
                }
                seenEdges.add(edgeKey)
                return true
            })?.map((edge) => ({
                ...edge,
                sourcePosition: 'bottom',
                targetPosition: 'top'
            }))

            requestAnimationFrame(() => {
                setEdges(edgeData)
            })
        }
    }, [setNodes, setEdges, organizationChartData, orgChartEdit])

    useEffect(() => {
        if (rollData.length > 0) {
            setRoleData(rollData)
        }
        if (departmentByOrgId.length > 0) {
            setDepByOrgId(departmentByOrgId)
        }
        if (designationByOrgId.length > 0) {
            setDesByOrgId(designationByOrgId)
        }
    }, [rollData, designationByOrgId, departmentByOrgId])

    useEffect(() => {
        setChildNodeCount(edges?.filter((data) => currentNode?.id === data?.source)?.length)
    }, [addState, isDeleteModal])

    const handleDrawerOpen = (data) => {
        setAddState({ ...addState, right: true })
        setCurrentNode(data)
    }

    const handleEditDrawerOpen = (data) => {
        setEditState({ ...editState, right: true })
        setCurrentNode(data)
    }

    const handleOpenNodeDeleteModal = (data) => {
        setCurrentNode(data)
        setIsDeleteModal(true)
    }

    const handleCloseNodeDeleteModal = () => {
        setIsDeleteModal(false)
        setCurrentNode({})
    }
    const handleCloseNodeDeleteModalConfirm = () => {
        setIsDeleteModalConfirm(false)
    }
    const handleRemoveNode = (allDesData, allDepData) => {
        const updatedNode = {
            ...currentNode,
            status: 2
        }
        const designation = typeof updatedNode?.designation === 'string' ? allDesData?.find(findDt => findDt?.name?.toLowerCase() === updatedNode?.designation?.toLowerCase())?.id || updatedNode?.designation : updatedNode?.designation
        const department = typeof updatedNode?.department === 'string' ? allDepData?.find(findDt => findDt?.name?.toLowerCase() === updatedNode?.department?.toLowerCase())?.id || updatedNode?.department : updatedNode?.department

        const chartRequestFormData = new FormData()
        const newNode = [{
            empId: updatedNode.id || 0,
            firstName: updatedNode.firstName || '',
            middleName: updatedNode.middleName || '',
            lastName: updatedNode.lastName || '',
            displayName: updatedNode.displayName || '',
            designationId: typeof designation === 'number' ? designation : 0,
            designation: typeof designation === 'string' ? designation : '',
            level: updatedNode.level,
            departmentId: typeof department === 'number' ? department : 0,
            department: typeof department === 'string' ? department : '',
            emailId: updatedNode.emailId || '',
            phoneNo: updatedNode.phoneNo || '',
            role: updatedNode.role.map(roleName => {
                const role = roleData.find(item => item.name === roleName)
                return role ? role.id : null
            }) || [],
            fromDate: typeof updatedNode.fromDate === 'object' ? updatedNode.fromDate.toISOString() : updatedNode.fromDate,
            toDate: typeof updatedNode.toDate === 'object' ? updatedNode.toDate.toISOString() : updatedNode.toDate,
            remarks: updatedNode?.remarks,
            atPresent: updatedNode.atPresent ? updatedNode.atPresent : true,
            profilePic: updatedNode.profilePic || '',
            reportsTo: updatedNode.reportsTo || 0,
            isActive: updatedNode?.isActive || false,
            x: updatedNode.pos?.x,
            y: updatedNode.pos?.y,
            status: updatedNode.status
        }]

        const appendFormDataOrgChart = (formData, data, parentKey = '') => {
            if (data && typeof data === 'object' && !Array.isArray(data)) {
                Object.keys(data).forEach(key => {
                    const newKey = parentKey ? `${parentKey}[${key}]` : key
                    appendFormDataOrgChart(formData, data[key], newKey)
                })
            } else if (Array.isArray(data)) {
                data.forEach((item, index) => {
                    const newKey = `${parentKey}[${index}]`
                    appendFormDataOrgChart(formData, item, newKey)
                })
            } else {
                formData.append(parentKey, data)
            }
        }
        newNode.forEach((obj, index) => {
            Object.keys(obj).forEach(key => {
                const newKey = `chartRequests[${index}][${key}]`
                appendFormDataOrgChart(chartRequestFormData, obj[key], newKey)
            })
        })
        setLoading(true)
        createOrganizationChart(chartRequestFormData, loginId, orgId)
            .then((response) => {
                if (response && response.data) {
                    getOrganizationChart(orgId, 1)
                    reset()
                    setCurrentNode({})
                    toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Employee details deleted successfully')}</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    setLoading(false)
                } else {
                    console.error('Invalid response structure:', response)
                    // Extract and display the specific error message from backend
                    const errorMessage = response?.err?.response?.data?.errors?.[0] ||
                        response?.err?.response?.data?.message ||
                        t('Error in deleting employee. Please try again!')
                    toast.error(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{errorMessage}</p></p>, {
                        position: 'top-right', theme: 'light', autoClose: 5000
                    })
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.error('Error posting organization chart data:', err)
                // Extract error message from the caught error
                const errorMessage = err?.response?.data?.errors?.[0] ||
                    err?.response?.data?.message ||
                    t('Error in deleting employee. Please try again!')
                toast.error(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{errorMessage}</p></p>, {
                    position: 'top-right', theme: 'light', autoClose: 5000
                })
                setLoading(false)
            })
        setIsDeleteModal(false)
        setIsDeleteModalConfirm(false)
    }

    const [meetingType, setmeetingType] = useState([
        { title: 'Executives Team', isSelected: true },
        { title: 'Risk Team', isSelected: true },
        { title: 'Compliance Team', isSelected: true }
    ])

    const onCheckboxValueChange = (value, keyEl) => {
        setmeetingType(meetingType?.map((mapData) => {
            if (mapData.title === keyEl?.title) {
                return { ...mapData, isSelected: keyEl?.isSelected !== true }
            } else return mapData
        }))
        setNodes((nds) =>
            nds.map((node) => {
                return {
                    ...node,
                    data: {
                        ...node?.data,
                        meetingType: node?.data?.meetingType?.map((mapData) => {
                            if (mapData.title === keyEl?.title) {
                                return { ...mapData, isSelected: keyEl?.isSelected !== true }
                            } else return mapData
                        })
                    }
                }
            })
        )
    }
    const onAdd = useCallback((currentData, newData, childNodeCount, resetAll) => {
        setLoading(true)
        const newNode = [{
            empId: 0,
            firstName: newData?.firstName || '',
            middleName: newData?.middleName || '',
            lastName: newData?.lastName || '',
            displayName: newData?.displayName || '',
            designationId: typeof newData?.designation === 'number' ? newData.designation : 0,
            designation: typeof newData?.designation === 'string' ? newData.designation : '',
            level: currentData?.level ? currentData?.level + 1 : 1,
            departmentId: typeof newData?.department === 'number' ? newData?.department : 0,
            department: typeof newData?.department === 'string' ? newData?.department : '',
            emailId: newData?.emailId || '',
            phoneNo: newData?.phoneNumber || '',
            phoneCode: newData?.phoneCode || '',
            phoneCountryCode: newData?.phoneCountryCode || '',
            role: newData?.role || [],
            fromDate: newData?.fromDate?.toISOString() || new Date().toISOString(),
            // toDate: null,
            atPresent: newData?.atPresent ? newData?.atPresent : false,
            profilePic: newData?.profilePic || '',
            reportsTo: currentData?.id || 0,
            isActive: newData?.isActive || false,
            status: 1,
            x: currentData?.id ? (childNodeCount === 0 ? 0 : (childNodeCount === 1 ? currentData?.pos?.x + 250 : 2 * currentData?.pos?.x)) : 0,
            y: currentData?.id ? currentData?.pos?.y + 250 : 0
        }]
        const chartRequestFormData = new FormData()

        // const appendFormDataOrgChart = (formData, data, parentKey = '') => {
        //     if (data && typeof data === 'object' && !Array.isArray(data) && parentKey === 'profilePic') {
        //         Object.keys(data).forEach(key => {
        //             const newKey = parentKey ? `${parentKey}[${key}]` : key
        //             appendFormDataOrgChart(formData, data[key], newKey)
        //         })
        //     } else if (Array.isArray(data)) {
        //         data.forEach((item, index) => {
        //             const newKey = `${parentKey}[${index}]`
        //             appendFormDataOrgChart(formData, item, newKey)
        //         })
        //     } else {
        //         if (parentKey?.includes('profilePic')) {
        //             const file = ConvertBase64ToFile(data)
        //             formData.append(parentKey, file)
        //         } else {
        //             formData.append(parentKey, data)
        //         }
        //     }
        // }

        // newNode.forEach((obj, index) => {
        //     Object.keys(obj).forEach(key => {
        //         const newKey = `chartRequests[${index}][${key}]`
        //         appendFormDataOrgChart(chartRequestFormData, obj[key], newKey)
        //     })
        // })
        createOrganizationChart({ chartRequests: newNode }, loginId, orgId)
            .then((response) => {
                if (response?.data) {
                    // Delay getOrganizationChart to ensure backend has processed the new node
                    // and React Flow has time to properly render the chart
                    setTimeout(() => {
                        getOrganizationChart(orgId, 1)
                    }, 500)
                    toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Employee added successfully')}</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    resetAll()
                    setnewNode({})
                    setAddState({ ...addState, right: false })
                    setmeetingType(meetingType)
                    setLoading(false)
                    if (location.pathname === '/GRC/manage-org-chart') {
                        sendInnviteFronOnboarding(orgId, newNode?.emailId)
                    }
                } else {
                    const warningMessage = response?.err?.response?.data?.errors
                    if (Array.isArray(warningMessage) && warningMessage.length > 0) {
                        warningMessage.forEach((message) => {
                            toast.warning(<p>{message}</p>, { position: 'top-right', theme: 'light' })
                        })
                    } else {
                        toast.warning(<p>{warningMessage}</p>, { position: 'top-right', theme: 'light' })
                    }
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.error('Error posting organization chart data:', err)
                toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>{t('Error in adding emloyee try again!')}</p></p>, {
                    position: 'top-right', theme: 'light'
                })
                setLoading(false)
            })
    }, [setNodes, setEdges])

    const onEdit = useCallback((data, allRoleData, allDesData, allDepData, resetAll) => {
        setLoading(true)
        const designation = typeof data?.designation === 'string' ? allDesData?.find(findDt => findDt?.name?.toLowerCase() === data?.designation?.toLowerCase())?.id || data?.designation : data?.designation
        const department = typeof data?.department === 'string' ? allDepData?.find(findDt => findDt?.name?.toLowerCase() === data?.department?.toLowerCase())?.id || data?.department : data?.department

        const newNode = [{
            empId: data?.id || 0,
            firstName: !data.isVacant ? data?.firstName : '',
            middleName: !data.isVacant ? data?.middleName || '' : '',
            lastName: !data.isVacant ? data?.lastName : '',
            displayName: !data.isVacant ? data?.displayName : '',
            designationId: typeof designation === 'number' ? designation : 0,
            designation: typeof designation === 'string' ? designation : '',
            level: data?.level,
            departmentId: typeof department === 'number' ? department : 0,
            department: typeof department === 'string' ? department : '',
            emailId: !data.isVacant ? data?.emailId : '',
            phoneNo: !data.isVacant ? data?.phoneNumber : '',
            phoneCode: !data.isVacant ? data?.phoneCode : '',
            phoneCountryCode: !data.isVacant ? data?.phoneCountryCode : '',
            role: data?.role?.map((roleName, index) => {
                const role = allRoleData?.find(item => item.name === roleName)
                return role ? role?.id : null
            })?.filter(roleId => roleId !== null),
            status: 1,
            isActive: data?.isActive || false,
            fromDate: typeof data?.fromDate === 'object' ? data?.fromDate?.toISOString() : data?.fromDate,
            // toDate: null,
            atPresent: data?.atPresent ? data?.atPresent : false,
            profilePic: data?.profilePic || '',
            reportsTo: data?.reportsTo || 0,
            x: data?.pos?.x,
            y: data?.pos?.y
        }]
        const chartRequestFormData = new FormData()

        const appendFormDataOrgChart = (formData, data, parentKey = '') => {
            if (data && typeof data === 'object' && !Array.isArray(data)) {
                Object.keys(data).forEach(key => {
                    const newKey = parentKey ? `${parentKey}[${key}]` : key
                    appendFormDataOrgChart(formData, data[key], newKey)
                })
            } else if (Array.isArray(data)) {
                data.forEach((item, index) => {
                    const newKey = `${parentKey}[${index}]`
                    appendFormDataOrgChart(formData, item, newKey)
                })
            } else {
                formData.append(parentKey, data)
            }
        }

        newNode.forEach((obj, index) => {
            Object.keys(obj).forEach(key => {
                const newKey = `chartRequests[${index}][${key}]`
                appendFormDataOrgChart(chartRequestFormData, obj[key], newKey)
            })
        })

        createOrganizationChart(chartRequestFormData, loginId, orgId)
            .then((response) => {
                if (response && response.data) {
                    getOrganizationChart(orgId, 1)
                    toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Employee details updated successfully')}</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    resetAll()
                    setEditState({ ...editState, right: false })
                    //     } else {
                    //         console.error('Invalid response structure:', response)
                    //         toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>{t('Error in updating employee details try again!')}</p></p>, {
                    //             position: 'top-right', theme: 'light'
                    //         })
                    //     }
                    // })
                    // .catch((err) => {
                    //     console.error('Error posting organization chart data:', err)
                    // })
                    setLoading(false)
                } else {
                    const warningMessage = response?.err?.response?.data?.errors
                    if (Array.isArray(warningMessage) && warningMessage.length > 0) {
                        warningMessage.forEach((message) => {
                            toast.warning(<p>{message || t('Error in updating employee details!')}</p>, { position: 'top-right', theme: 'light' })
                        })
                    } else {
                        toast.warning(<p>{warningMessage || t('Error in updating employee details!')}</p>, { position: 'top-right', theme: 'light' })
                    }
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.error('Error posting organization chart data:', err)
                toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>{t('Error in adding emloyee try again!')}</p></p>, {
                    position: 'top-right', theme: 'light'
                })
                setLoading(false)
            })
    }, [setNodes, setEdges])

    const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), [])

    const chartRequest = nodes?.filter((filterdt, filteridx) => filteridx !== 0)?.map((dt) => {
        const foundDesignation = desByOrgId.find(des => des?.name?.toLowerCase() === dt?.data?.designation?.toLowerCase())
        const designationId = foundDesignation ? foundDesignation.id : ''

        const foundDepartment = depByOrgId.find(dep => dep?.name?.toLowerCase() === dt?.data?.department?.toLowerCase())
        const departmentId = foundDepartment ? foundDepartment.id : ''

        return {
            empId: +dt?.data?.id,
            x: dt?.position?.x,
            y: dt?.position?.y
        }
    })
    const handleNext = (data) => {
        setLoading(true)
        editOrganizationChartNode(chartRequest)
            .then((response) => {
                setOrgChartEdit(false)
                toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Employees position updated successfully')}</p></p>, {
                    position: 'top-right', theme: 'light'
                })
                const userId = localStorage.getItem('userId')
                getAllFeaturesF(userId)
                setOrgChartEdit(false)
                setLoading(false)
            })
            .catch((err) => {
                console.error('Error posting organization chart data:', err)
                toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>{t('Error in creating employee details try again!')}</p></p>, {
                    position: 'top-right', hideProgressBar: true, theme: 'light'
                })
                setLoading(false)
            })
    }
    const loadings = false
    return (
        <React.Fragment>
            <Loading isLoading={editOrganizationChartNodeLoading || loadings} />
            <ReactFlow
                nodes={nodes}
                edges={edges}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onConnect={onConnect}
                nodeTypes={nodeTypes}
                fitView
                className="bg-teal-50"
                edgeTypes={edgeTypes}
            >
                <Background color='hsl(var(--popover))' style={{ opacity: '40%' }} variant='lines' gap={20} >
                </Background>
                <Controls className='custom-controls' />
                <Panel position="top-right">
                    <AddNodeDrawer nodes={nodes} newNode={newNode} setnewNode={setnewNode} currentNode={currentNode} setCurrentNode={setCurrentNode} addState={addState} childNodeCount={childNodeCount} onAdd={onAdd} setAddState={setAddState} loading={loading} setLoading={setLoading} />
                    <EditNodeDrawer nodes={nodes} currentNode={currentNode} setCurrentNode={setCurrentNode} editState={editState} onEdit={onEdit} setEditState={setEditState} loading={loading} setLoading={setLoading} />
                </Panel>
                <div className="checkbox__controls">
                    <div className="sub_checkbox_controls">
                        {meetingType.map((el, key) => {
                            return (
                                <div key={key} className='flex mt-auto mr-4'>
                                    <Checkbox
                                        checked={el.isSelected}
                                        borderColor={`hsl(var(--${el?.title?.replace(' Team', '')}))`}
                                        onCheckedChange={(e) => onCheckboxValueChange(e, el)}
                                        color={`hsl(var(--${el?.title?.replace(' Team', '')}))`}
                                        className={el.isSelected ? 'my-auto border-none' : 'my-auto'}
                                    />
                                    {el.title && <label className='grc-label ml-2'>{el.title?.replace('Executives', 'Executive')}</label>}
                                </div>
                            )
                        })}
                    </div>
                    {!activeStepper && <div className='flex'>
                        {!orgChartEdit && <Tooltip title="Edit" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <Button variant="outline" className="grc-btn-one flex items-center justify-center !p-[6px] mx-3 !border-2 !border-[#b2d9d8]"
                                onClick={() => setOrgChartEdit(true)}
                            >
                                <EditPencilIcon />
                            </Button>
                        </Tooltip>}
                        {orgChartEdit && <><Tooltip title="Save" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <Button variant="outline" className="grc-btn-one flex items-center justify-center !p-[6px] !border-2 !border-[#b2d9d8]"
                                onClick={() => handleNext()} disabled={loading || editOrganizationChartNodeLoading}
                            >
                                <IoMdSave size={26} />
                            </Button>
                        </Tooltip>
                            <Tooltip title="Cancel" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                <Button variant="outline" className="grc-btn-one flex items-center justify-center !p-[5px] mx-3 !border-2 !border-[#cb353f44]"
                                    onClick={() => { setOrgChartEdit(false); getOrganizationChart(orgId, 1) }} disabled={getOrganizationChartLoading}
                                >
                                    <IoCloseSharp size={26} color='hsl(var(--red-light))' />
                                </Button>
                            </Tooltip></>}
                    </div>}
                </div>
            </ReactFlow>

            <Dialog
                open={isDeleteModalConfirm}
                onClose={handleCloseNodeDeleteModalConfirm}
            >
                <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--destructive))', flexDirection: 'row', height: '40px', justifyContent: 'space-between' }}>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#fff' }}>{t('Confirmation')}</div>
                    <Tooltip title="Close" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <CrossCircledIcon onClick={() => handleCloseNodeDeleteModalConfirm()} style={{ height: '30px', width: '30px', fontWeight: 'bold', color: 'hsl(var(--card))', cursor: 'pointer' }} />
                    </Tooltip>
                </DialogTitle>
                <DialogContent style={{ padding: '15px' }}>
                    <DialogContentText style={{ fontWeight: 'bold', width: '100%' }} id="alert-dialog-description">
                        <div className='mb-5 w-[60%]'>
                            <DatePickerInput
                                errors={errors}
                                control={control}
                                required
                                rules={{ required: t('This field is required') }}
                                name='fromDate'
                                label={<span className='text-[12px]'>{t('Effective Last Date')}</span>}
                                register={register}
                                type="text"
                                value={currentNode?.toDate || ''}
                                onValueChange={(e) => setCurrentNode({ ...currentNode, toDate: e?.toISOString() })}
                            />
                        </div>
                        <div>
                            <Textarea className={cn('ml-[0px]')} label={<span className='text-[12px]'>{t('Remarks')}</span>} rules={{
                                validate: (value) => {
                                    if (!value) return t('This field is required')
                                    // if (value.length > 251) return t('Character count should not exceed 250')
                                    return true
                                }
                            }} register={register} value={currentNode?.remarks || ''} type="text" placeholder="Enter Remarks" onValueChange={(e) => {
                                const value = e.slice(0, 250)
                                setCurrentNode({ ...currentNode, remarks: value })
                            }} name="remarks" errors={errors} control={control} required maxLength={250} />
                        </div>

                    </DialogContentText>
                    <Divider />
                    <DialogActions style={{ padding: '10px 0 0 0', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                        <Button variant="outline" onClick={() => handleCloseNodeDeleteModalConfirm()}>Cancel</Button>
                        {nodes.length > 1 && childNodeCount === 0 && <Button variant='destructive' onClick={handleSubmit(() => handleRemoveNode(desByOrgId, depByOrgId))} disabled={isLoading || isSubmitting}>{t('Yes')}</Button>}
                    </DialogActions>
                </DialogContent>
            </Dialog>

            <Dialog
                open={isDeleteModal}
                onClose={handleCloseNodeDeleteModal}
            >
                <Box sx={{ width: 400 }} >
                    <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--destructive))', flexDirection: 'row', height: '40px', justifyContent: 'space-between' }}>
                        <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#fff' }}>{t('Remove User')}</div>
                        <Tooltip title="Close" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <CrossCircledIcon onClick={() => handleCloseNodeDeleteModal()} style={{ height: '30px', width: '30px', fontWeight: 'bold', color: 'hsl(var(--card))', cursor: 'pointer' }} />
                        </Tooltip>
                    </DialogTitle>
                    <DialogContent>
                        {nodes?.length > 1 && childNodeCount === 0
                            ? <Stack direction="column" spacing={2}>
                                <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <Avatar sx={{ width: 60, height: 60 }} src={currentNode?.profilePic ? `data:${currentNode?.profilePic?.contentType};base64,${currentNode?.profilePic?.file}` : currentNode?.name} alt={currentNode?.name} />

                                    <p className='text-b5' style={{ paddingLeft: '20px' }} >{currentNode?.displayName}</p>
                                </div>
                                <div className="bg-gray-800 text-white rounded-md">
                                    <p className="font-bold text-destructive">
                                        Warning: You are about to delete this user.
                                    </p>
                                    <p className="mb-3 ">
                                        Before you continue, please make sure:
                                    </p>
                                    <ul className="list-disc pl-6 space-y-2">
                                        <li><span className="font-semibold">Compliance&nbsp;</span>: All compliance tasks associated with this user have been reassigned or completed to avoid workflow disruptions.</li>
                                        <li><span className="font-semibold">Risk Check&nbsp;</span>: All risk-related tasks assigned to this user will become unassigned. To prevent workflow disruption, assign the same role to another user within the same department.</li>
                                    </ul>
                                    <p className="mt-3 text-muted">
                                        <strong className='text-destructive'>Note&nbsp;:&nbsp;</strong>The user&apos;s activity log will be permanently deleted. To preserve data and maintain the reporting structure of their direct reports, consider marking the position as &quot;Vacant&quot; instead of deleting the user.
                                    </p>
                                </div>

                                <DialogContentText style={{ fontWeight: 'bold', display: 'flex' }} id="alert-dialog-description">
                                    <p>{t('Are you Sure ?')}</p>
                                    <p style={{ marginLeft: '10px', color: 'hsl(var(--destructive))', fontWeight: 'bold' }}>{t('There is no Undo.')}</p>
                                </DialogContentText>
                            </Stack>
                            : <Stack direction="column" spacing={2}>
                                <DialogContentText style={{ fontWeight: 'bold', padding: '10px 0px 10px 0px' }} id="alert-dialog-description">
                                    {nodes.length === 1 ? t("You can't remove a management team.") : t('This card has subordinate cards. Delete them before attempting to remove this card.')}
                                </DialogContentText>
                                <DialogContentText style={{ color: 'hsl(var(--destructive))', fontWeight: 'bold' }} id="alert-dialog-description">
                                    {t('You cannot delete this node.')}
                                </DialogContentText>
                            </Stack>}
                    </DialogContent>
                    <Divider />
                    <DialogActions style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                        <Button variant="outline" onClick={() => handleCloseNodeDeleteModal()}>Close</Button>
                        {nodes.length > 1 && childNodeCount === 0 && <Button variant='destructive' onClick={() => setIsDeleteModalConfirm(true)} >{t('Continue')}</Button>}
                    </DialogActions>
                </Box>
            </Dialog>
        </React.Fragment>
    )
}

OrganizationChart.propTypes = {
    edges: PropTypes.array,
    setEdges: PropTypes.func,
    onEdgesChange: PropTypes.func,
    nodes: PropTypes.array,
    setNodes: PropTypes.func,
    onNodesChange: PropTypes.func
}

export default OrganizationChart
